// Components
import TopNavigationDesktopItem from "components/molecules/TopNavigationDesktopItem";

// Constants
import {
  TOP_NAVIGATION_DESKTOP,
  TOP_NAVIGATION_DESKTOP_ID_ENUM,
} from "constants/navigation/topNavigationDesktop";

import "./styles.sass";
import { getEnv } from "../../../utils/hostname";

const TopNavigationDesktop = () => {
  const isStage =
    getEnv() === "stage" || getEnv() === "dev" || getEnv() === "local";
  return (
    <div className="TopNavigationDesktop">
      {TOP_NAVIGATION_DESKTOP.map((navigation) => {
        if (
          navigation.id === TOP_NAVIGATION_DESKTOP_ID_ENUM.SPORT &&
          !isStage
        ) {
          return null;
        }
        return (
          <div className="TopNavigationDesktop__item" key={navigation.id}>
            <TopNavigationDesktopItem data={navigation} />
          </div>
        );
      })}
    </div>
  );
};

export default TopNavigationDesktop;
